var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29195 10.2929C8.10514 10.4818 8.00037 10.7368 8.00037 11.0024C8.00037 11.2681 8.10514 11.523 8.29195 11.7119L11.2309 14.6769C11.4489 14.8919 11.7309 14.9989 12.0099 14.9989C12.2889 14.9989 12.5659 14.8919 12.7789 14.6769L15.7089 11.7219C15.8955 11.5329 16.0001 11.278 16.0001 11.0124C16.0001 10.7469 15.8955 10.492 15.7089 10.3029C15.6171 10.2098 15.5077 10.1358 15.387 10.0853C15.2663 10.0347 15.1368 10.0087 15.0059 10.0087C14.8751 10.0087 14.7456 10.0347 14.6249 10.0853C14.5042 10.1358 14.3948 10.2098 14.3029 10.3029L12.0049 12.6199L9.69795 10.2929C9.60591 10.2001 9.4964 10.1264 9.37574 10.0762C9.25508 10.0259 9.12566 10 8.99495 10C8.86423 10 8.73481 10.0259 8.61415 10.0762C8.49349 10.1264 8.38398 10.2001 8.29195 10.2929Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.ad357fd1.svg";
export { ForwardRef as ReactComponent };